import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  phone?: string;
}

interface UserState {
  user: UserProfile | null;

  // Actions
  setUser: (user: UserProfile) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: null,

      setUser: (user: UserProfile) => set({ user }),

      clearUser: () => set({ user: null }),
    }),
    {
      name: 'user-storage',
    }
  )
);
